'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Chọn thời gian'
};

exports['default'] = locale;